<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
            <d-col col sm="6" class="text-left text-sm-left mb-4 mb-sm-0">
        <h3 class="page-title">
          <template v-if="isEdit">
            <template v-if="data.type === 'roll'">Edytuj typ bułki</template>
            <template v-else>Edytuj jednostkę</template>
          </template>
          <template v-else>
            <template v-if="data.type === 'roll'">Nowy typ bułki</template>
            <template v-else>Nowa jednostka</template>
          </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="primary"
          outline
          @click.prevent="$router.push('/admin/units')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">done</i>
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-card-body>
          <validation-observer
            v-if="allDataLoaded"
            ref="unit-form"
            tag="form">
            <div class="form-group">
              <label for="name">
                Nazwa:
              </label>

              <validation-provider
                rules="required"
                name="name"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.name" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="name">
                Typ:
              </label>

              <div>
                <d-form-radio v-model="data.type" value="roll">Bułka</d-form-radio>
                <d-form-radio v-model="data.type" value="unit">Jednostka</d-form-radio>
              </div>
            </div>

            <div class="form-group">
              <toggle-switch v-model="data.is_countable">
                Policzalne?
              </toggle-switch>
            </div>

            <div class="form-group">
              <label for="name">
                Nazwa na podglądzie:
              </label>

              <validation-provider
                rules="required"
                name="preview_name"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.preview_name" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
            Trwa ładowanie danych&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
          </d-alert>
        </d-card-body>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ToggleSwitch from './../common/ToggleSwitch.vue';

export default {
  name: 'unit-form',
  components: {
    'toggle-switch': ToggleSwitch
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        type: 'unit',
        is_countable: false,
        preview_name: ''
      },
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/system/units/item/',
        instanceFields: ['id', 'name', 'type', 'is_countable', 'preview_name'],
        loadedKey: 'loaded',
        booleanFields: ['is_countable']
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['unit-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = this.isEdit ? '/system/units/update/' + this.id : '/system/units/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: this.prepareFormData(),
        successTitle: this.data.type === 'roll' ? 'Zapisano typ byłki' : 'Zapisano jednostkę',
        successText: this.data.type === 'roll' ? 'Wybrany typ byłki został zapisany' : 'Wybrana jednostka została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapis nie powiódł się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/admin/units')
        }
      });
    },
    prepareFormData () {
      this.data.is_countable = this.data.is_countable ? 1 : 0;
      return this.data;
    }
  }
};
</script>
